export default function BeforeAfter() {
  return (
    <div data-testid="before-after" className="mt-10 grid gap-6 md:grid-cols-2">
      <figure>
        <div className="aspect-[4/3] overflow-hidden rounded-2xl border border-slate-300 bg-[#e8e8e8] p-3 font-serif text-[11px] text-[#333]">
          <div className="bg-[#003399] px-2 py-1 text-center text-white">BENVENUTI NEL SITO DELLA DITTA ESEMPIO</div>
          <div className="mt-2 flex gap-2">
            <div className="w-1/4 space-y-1 bg-[#ccc] p-1 text-[10px] underline text-[#0000ee]"><p>Home</p><p>Chi siamo</p><p>Prodotti</p><p>Dove siamo</p><p>Contatti</p></div>
            <div className="flex-1 space-y-2">
              <p className="text-[#cc0000]">*** NOVITÀ!!! ***</p>
              <p>La nostra ditta opera da molti anni nel settore con serietà e professionalità. Per informazioni scaricate il catalogo PDF (12 MB) oppure telefonate in orario d’ufficio.</p>
              <div className="h-16 bg-[#bbb]" />
              <p className="text-[9px]">Sito ottimizzato per risoluzione 1024x768</p>
            </div>
          </div>
        </div>
        <figcaption className="mt-3 text-sm text-slate-500"><strong className="text-slate-900">Prima (esempio):</strong> testo piccolo, menu non leggibile su smartphone, nessun contatto immediato.</figcaption>
      </figure>
      <figure>
        <div className="aspect-[4/3] overflow-hidden rounded-2xl border border-slate-200 bg-white p-5">
          <div className="flex items-center justify-between text-[10px] font-semibold"><span className="font-display text-xs font-extrabold">Ditta Esempio</span><span className="rounded-full bg-blue-600 px-3 py-1 text-white">Chiedi preventivo</span></div>
          <p className="mt-6 text-[9px] font-semibold uppercase tracking-[0.2em] text-blue-600">Serramenti su misura</p>
          <p className="mt-2 font-display text-xl font-extrabold leading-tight text-slate-900">Finestre e porte progettate per durare.</p>
          <div className="mt-4 grid grid-cols-3 gap-2">
            {["Sopralluogo", "Catalogo", "Progetti"].map((t) => <div key={t} className="rounded-lg bg-slate-50 p-2 text-[9px] font-semibold">{t}</div>)}
          </div>
          <div className="mt-3 flex gap-2 text-[9px]"><span className="rounded-full bg-[#25D366] px-3 py-1 text-white">WhatsApp</span><span className="rounded-full border px-3 py-1">Chiama</span></div>
        </div>
        <figcaption className="mt-3 text-sm text-slate-500"><strong className="text-slate-900">Dopo (esempio):</strong> messaggio chiaro, azioni evidenti, struttura leggibile da ogni dispositivo.</figcaption>
      </figure>
    </div>
  );
}
